__webpack_require__.p = "/games/video-postcard-2025/";